import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿En qué formato recibo el MegaPack Universitario?',
    answer: '100% digital en PDF, acceso inmediato por email.'
  }, {
    question: '¿Para qué carreras sirve?',
    answer: 'Para cualquier carrera universitaria, pública o privada.'
  }, {
    question: '¿Cuánto tiempo tengo para acceder?',
    answer: 'Acceso de por vida desde el momento de la compra.'
  }, {
    question: '¿Tiene garantía?',
    answer: 'Sí, 7 días de garantía total sin preguntas.'
  }, {
    question: '¿Cómo pago?',
    answer: 'Mercado Pago, tarjeta de crédito o débito.'
  }];
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="faqs" className="w-full py-24 bg-transparent px-4" data-id="element-176">
      <div className="max-w-3xl mx-auto flex flex-col items-center" data-id="element-177">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-black text-white mb-16 text-center leading-tight" data-id="element-178">
          Preguntas frecuentes ❓
        </motion.h2>

        <div className="w-full flex flex-col gap-4" data-id="element-179">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-cardBg border border-white/5 rounded-xl overflow-hidden hover:border-white/10 transition-colors" data-id="element-180">
              <button onClick={() => toggleFaq(index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-181">
                <span className="text-lg md:text-xl font-bold text-white" data-id="element-182">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} data-id="element-183">
                  <ChevronDownIcon className="w-6 h-6 text-gradPurple shrink-0 ml-4" data-id="element-184" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-185">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-186">
                    <div className="p-6 pt-0 text-textMuted text-base font-medium" data-id="element-187">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}